import { SendInvitation } from "./SendInvitation";

export default SendInvitation;
